<template>
	<div id="product">
		<div class="banner">
			<img :src="advsetting.product_topbanner" class="pic">
		</div>
		<breadcrumb/>
		<div class="widthBox">
			<div class="viewA">
				<img :src="advsetting.product_leftmap" class="pic hidden-xs-only" alt="">
				<div class="txt">
					<img :src="advsetting.product_rightlogo" class="logo" alt="">
					<p>{{advsetting.describe}}</p>
				</div>
				<img :src="advsetting.product_leftmap" class="pic hidden-sm-and-up" alt="">
			</div>
		</div>
		<div class="main bgColor">
			<div class="widthBox">
				<pageTitle en="ADVANTAGE" title="主营产品" />
				<div v-if="goods_list.length > 0" class="list acea-row">
					<div @click="toPage(item.id)" v-for="item in goods_list" class="item">
						<img :src="item.main_figure" class="pic" alt="">
						<div class="txt">
							<h4>{{item.product}}</h4>
							<p class="line3">{{item.describe}}</p>
							<div class="more acea-row row-between">
								查看详情
								<span class="iconfont icon-jiantou_xiangyou_o"></span>
							</div>
						</div>
					</div>
				</div>
				<div class="listNo" v-else>
					- 暂无更多 -
				</div>
				<div style="margin-top:40px;">
					<pagination @getPage="getPage" :current-page="1" :page-size="6" :total="total" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import breadcrumb from '@/components/breadcrumb.vue'
import pageTitle from '@/components/pageTitle.vue'
import pagination from '@/components/pagination.vue'
import metaInfo from "@/utils/metaInfo.js";
export default {
	metaInfo,
  name: 'product',
  components: { breadcrumb,pageTitle,pagination },
  data:function(){
  	  return{
		  advsetting:{},
		  page:1,
		  goods_list:[],
		  total:0
  	  }
  },
  created() {
  	this.getData()
  },
  methods:{
	  getPage(e){
		  this.goods_list = []
		  this.page = e
		  this.getData()
	  },
	  toPage(e){
		  this.$router.push({path:'/pro_detail', query:{id:e}});
	  },
	  getData(){
		this.$api.post('home/Index/productlist', {
			page:this.page,
		}).then(res => {
			this.advsetting = res.data.advsetting
			this.goods_list = res.data.goods_list
			this.total = res.data.goodstotal
		})
	  },
  }
}
</script>

<style lang="scss">
	#product{
		.bgColor{
			background:#FAF9F9;
		}
		.listNo{
			text-align: center;
			line-height:100px;
			font-size:16px;
			color:#999;
			background:#FFF;
		}
		.banner{
			.pic{
				width:100%;
			}
		}
		.viewA{
			padding:80px 0 30px;
			&::after{
				content:'';display: block;width:0;height:0;overflow: hidden;clear: both;
			}
			.pic{
				width:500px;
				float:left;
			}
			.txt{
				margin-left:550px;
				.logo{
					width:156px;
				}
				p{
					color:#666;
					line-height:28px;
					margin-top:24px;
				}
			}
		}
		.main{
			padding:40px 0;
			.list{
				.item{
					margin-top:40px;
					width:calc(100% / 3 - 15px);
					margin-right:22px;
					background:#EFEEEE;
					transition: 0.2s;
					cursor: pointer;
					&:nth-child(3n){
						margin-right:0;
					}
					&:hover{
						padding-bottom:20px;
						margin-top:20px;
					}
					.pic{
						width:100%;
					}
					.txt{
						padding:20px;
						h4{
							font-size:20px;
							color:#124098;
							font-weight: 500;
							padding-bottom:20px;
						}
						p{
							border-top:1px solid #E6E5E5;
							margin-bottom:20px;
							padding-top:20px;
							line-height:24px;
							color:#333;
						}
						.more{
							border-top:1px solid #E6E5E5;
							padding:20px 0 0;
							.iconfont{
								font-size:20px;
							}
						}
					}
				}
			}
		}
	}
	
	@media screen and(max-width:768px) {
		#product{
			.viewA{
				padding:20px;
				.txt{
					margin-left:0;
					p{
						margin-top:10px;
					}
				}
				.pic{
					width:100%;
					float:none;
				}
			}
			.main{
				.list{
					margin-top:20px;
					.item{
						width:calc((100% / 2) - 5px);
						margin-right:0;
						margin-top:10px;
						&:nth-child(even){
							margin-left:10px;
						}
						.txt{
							padding:10px;
							h4{
								font-size:14px;
								padding-bottom:0;
							}
							p{
								border:0;
								padding-top:10px;
								margin-bottom:0;
							}
							.more{
								display: none;
							}
						}
					}
				}
			}
		}
	}
</style>
